import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Catalogo } from '../../models/catalogo';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-cataloghi',
  templateUrl: './cataloghi.component.html',
  styleUrls: ['./cataloghi.component.css']
})
export class CataloghiComponent implements OnInit {
  selectedValueStato:string;
  cataloghi: Catalogo[]=[];

//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "Codice",
    "Nome",
    "Descrizione",
    "Datavalidodal",
    "Datavalidoal",
    "Categoria",
    "Codicefornitore",
    "edit",
    "articoli"];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Catalogo>(this.cataloghi);
  @ViewChild('paginator') paginator: MatPaginator;
  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit() {

    this.aggiornaLista();


    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Codice",true);
    this.sortedDirection.set("Nome",true);
    this.sortedDirection.set("Descrizione",true);
    this.sortedDirection.set("Datavalidodal",true);
    this.sortedDirection.set("Datavalidoal",true);
    this.sortedDirection.set("Categoria",true);
    this.sortedDirection.set("Codicefornitore",true);
    this.sortedDirection.set("edit",true);
  }


  cancel(){
    /*
    this.selectedValueStato="";
    this.stato=new Statolavorazione();
    this.aggiornaLista();
    */
  }



  delete(catalogo: Catalogo): void {
    this.commonService.deleteCatalogo(catalogo).subscribe(data => {
      this.cataloghi = this.cataloghi.filter(c => c !== catalogo);
    });
  }


  aggiornaLista(){
    this.cataloghi=[];
     this.commonService.getAllCataloghi().subscribe((res) => {
       this.cataloghi=res;
       this.refreshLista(this.cataloghi);
      });

    }

   refreshLista(listacataloghi:Catalogo[]){
     this.cataloghi=listacataloghi;
     this.dataSource = new MatTableDataSource<Catalogo>(this.cataloghi);
     this.dataSource.paginator = this.paginator;
   }

  new(){
    this.commonService.selectedCatalogo=undefined;
    this.router.navigate(['addcatalogo']);
  }
  edit(catalogo: Catalogo): void {
      this.commonService.selectedCatalogo=catalogo;
      this.router.navigate(['addcatalogo']);
  }

  gotoarticoli(catalogo: Catalogo): void {
    this.commonService.selectedCatalogo=catalogo;
    this.router.navigate(['articoli']);
}


  getConfigurazione(){
    return configurazione.catalogo;
  }

  manageClick(attributo: string){
    let tempList:Catalogo[];
    tempList=this.cataloghi;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);

     this.dataSource = new MatTableDataSource<Catalogo>(this.cataloghi);

   }

}
